module.exports = __webpack_public_path__ + "img/banner1.de8029f7.jpg";